  
import { Dynamic } from "../../../../../controllers/conductor";
import { getController } from "../../../../../controllers/getter";
import { MainWindow } from "../../../MainWindow";

import "../../../../../styles/forms.css";
import { Button, IconButton } from "../../../../widgets/buttons";
import { getMonthName, parseDateWithTime } from "../../../../../misc/date";
import { ScrollingTable } from "../../../../widgets/table";

import React from "react";
import { Blocker } from "../../../../widgets/misc";
import { AlertDrawer } from "../../../../sections/sidebar/AlertDrawer";
import { MonthYearSelector } from "../../../../widgets/date_selector";
import { LoadingAnimation } from "../../../../widgets/loading";
import { SameDayLguSubmissionsController } from "../../../../../controllers/submissions/sameday/LGU";
import { useParams } from "react-router-dom";
import { ApprovalIcon } from "../../../../widgets/approval";
import Client from "../../../../../Client";


function SameDayLGUSubmissions() {

    const params = useParams();
    const ref = {
        lgu: params.lguid,
        month: Number(params.month),
        year: Number(params.year)
    };

    const controller = getController(SameDayLguSubmissionsController, { ref });
    if(controller.isInitialized) controller.changeDate(ref.month, ref.year);

    const { notifiers, status } = controller;
    
    return (<MainWindow currentTab="forms" subtab="sameday">
        <Dynamic conductor={[ notifiers.ready, notifiers.unauthorized ]} child={()=>
            status.unauthorized ? <Unauthorized /> : status.ready ? <Main controller={controller} /> : <LoadingWindow />
        } />
    </MainWindow>);
}

function Unauthorized() {
    return <div>Unauthorized</div>;
}

function LoadingWindow() {
    return (<center><LoadingAnimation /> Loading...</center>);
}


function Main({ controller }) {
    return <div className="form-main">
        <div className="alert-drawer-wrapper"><AlertDrawer controller={controller.notifiers.alert} /></div>
        <Header controller={controller} />
        <MainSection controller={controller} />
        <Footer controller={controller} />
    </div>;
}


function Header({ controller }) {
    const { notifiers } = controller;

    const onDateChange = ({ month, year }) => controller.changeDate(month, year);

    return <Dynamic conductor={notifiers.reloaded} child={()=>{
        const data = controller.data;
        const lguName = data.lgu.name;
        const province = data.lgu.province.name;
        const date = getMonthName(data.month) + " " + data.year;
        const { month, year } = controller.reference;
        const canAdd = [ "admin", "lgu"].includes(Client.account.role);

        return <header>
            <div>
                <h2>Sameday Visit Submissions</h2>
                <h5>{ `${lguName}, ${province} • ${date}` }</h5>
            </div>
            <div className="buttons">
                <IconButton icon="refresh" onClick={() => controller.refresh()} />
                { canAdd ? <Button onClick={() => controller.editDraft()}>ADD</Button> : "" }
                <MonthYearSelector month={month} year={year} onChange={onDateChange} />
            </div>
        </header>;
    }} />;
}

function MainSection({ controller }) {
    const { notifiers, status } = controller;

    return <Dynamic conductor={notifiers.reloaded} child={()=>{
        return <main className="main">
            <HighlightSection controller={controller} />
            <ListSection controller={controller}/>
            <Dynamic conductor={notifiers.reloading} child={()=>
                <Blocker active={status.reloading}><center><LoadingAnimation />Loading data...</center></Blocker>
            } />
        </main>
    }} />;
        
    
}

function HighlightSection({ controller }) {
    const currentApproved = controller.data.currentApproved;
    let columns; 
    let rows;


    if(currentApproved) {
        const { author, submittedOn, approvals } = currentApproved;
        columns = [
            { title: "DATE SUBMITTED", width: "30%" },
            { title: "AUTHOR", width: "25%" },
            { title: "PROVINCE", width: "15%" },
            { title: "REGION", width: "15%" },
            { title: "PUBLISHED", width: "15%" },
        ];

        rows = [[
            parseDateWithTime(submittedOn),
            author.fullname || "Unknown",
            approvals.province.length > 0 ? <ApprovalIcon />  : "",
            approvals.region.length > 0 ? <ApprovalIcon />  : "",
            currentApproved.published ? <ApprovalIcon />  : "",
        ]];
    }

    const onRowClick = () => {
        controller.viewSubmission(currentApproved.docId);
    };

    
    return currentApproved ? <div className="highlight-section">
        <h3>CURRENT APPROVED</h3>
        <ScrollingTable columns={columns} rows={rows} onRowClick={onRowClick} />
    </div> : "";
}

function ListSection({ controller }) {
    const columns = [
        { title: "ID", width: "25%" },
        { title: "DATE SUBMITTED", width: "25%" },
        { title: "AUTHOR", width: "25%" },
        { title: "LAST UPDATED", width: "25%" },
    ];

    const { data } = controller;

    if(data.submissions.length === 0) return <center>No submissions yet.</center>;

    const rows = data.submissions.map((submission, si) => {
        const { refId, submittedOn, author, lastUpdatedOn } = submission;

        const lastUpdateDate = parseDateWithTime(lastUpdatedOn);

        return [
            refId,
            parseDateWithTime(submittedOn),
            author ? author.fullname : "Unknown",
            lastUpdateDate
        ];
    });

    const onRowClick = (rowIndex) => {
        const submission = data.submissions[rowIndex];
        controller.viewSubmission(submission.id);
    };

    const hasCurrentApproved = data.currentApproved ? true : false;

    return <div className="table-wrapper">
        <ScrollingTable header={hasCurrentApproved ? <h3>OTHER SUBMISSIONS</h3> : ""} columns={columns} rows={rows} onRowClick={onRowClick} />
    </div>;
}

function Footer({ controller }) {
    return <footer></footer>;
}



export default SameDayLGUSubmissions;